export default "__VITE_ASSET__BMV6LN0Q__"